// prettier-ignore
import { Box, Typography, CircularProgress, Backdrop, Tooltip, Avatar, IconButton, ClickAwayListener, Link } from '@material-ui/core';
import React, { Component, Fragment } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import queryString from 'query-string';
import PageHeader from '../../components/common/PageHeader';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty, keysIn } from '../../utils/lodash';
import { Systems, OrderStatusPopup } from '../../components/Systems';
import SnakBar from '../../components/SnakBar';
import { forwardTo } from '../../utils/helper';
import { get } from '../../utils/lodash';
import { updateCompanyInfo } from '../Layouts/actions';
import { HelpIcon } from '../../components/Systems/Icons';
import Icons from '../../components/Dashboard/Icons';
import { LPPOverview } from '../../components/Systems/constant';
import {
  getLREPlans,
  getSiteLists,
  setPurchase,
  getLREItems,
  updateLREItems,
  addItemsToCart,
  getSelectedItems,
  setPurchasedList,
  setTransactionStatus,
  getPlansBySiteId,
  getAgreementFile
} from './actions';
import { localeMoment as moment } from '../../components/common/moment';
import { getCountryCode } from '../../components/Dashboard/helper';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: '0px 1px 6px #00000029',
    fontSize: 14,
    padding: theme.spacing(1.5, 2),
    maxWidth: 350,
    minWidth: 350,
    '& p': {
      fontSize: 14
    }
  },
  arrow: { color: theme.palette.common.white, fontSize: 16 },
  popper: {
    pointerEvents: 'auto'
  }
}))(Tooltip);

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5)
  },
  chip: { margin: 'auto', marginLeft: theme.spacing(1) },
  flexWrapper: { display: 'flex', alignItems: 'flex-end' },
  backdrop: {
    zIndex: 11,
    color: theme.palette.primary.main
  },
  tierIcon: {
    width: theme.spacing(7.5),
    height: theme.spacing(10),
    position: 'absolute',
    right: 0,
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(7.5),
      height: theme.spacing(10)
    }
  },
  label: {
    color: theme.palette.primary.lightBlack,
    fontSize: 12,
    paddingLeft: theme.spacing(0.5)
  },
  colorWrapper: {
    marginBottom: theme.spacing(0.75)
  },
  important: { color: 'red' },
  labelWrapper: { display: 'flex' },
  headerContainer: {
    display: 'flex',
    alignSelf: 'flex-end',
    flexDirection: 'column'
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  headerHelpIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginLeft: theme.spacing(1),
    padding: 0
  },
  helpIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
  linkColour: {
    color: theme.palette.tertiary.main,
    cursor: 'pointer',
    fontSize: 14
  },
  discountLabel: {
    fontSize: 12,
    color: '#9D9D9D'
  },
  discountText: {
    color: '#F37320',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: 0.8
  },
  additionalBox: {
    width: theme.spacing(10),
    zIndex: 1,
    height: theme.spacing(10),
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(5)
    }
  },
  discountWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  cutboxshadow: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(-3.5),
    transform: 'rotate(45deg)',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 6px #00000029'
  },
  discount: {
    width: theme.spacing(30),
    height: theme.spacing(7),
    marginRight: theme.spacing(4),
    boxShadow: '0px 0px 6px #00000029'
  },
  tierWrapper: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    height: theme.spacing(10)
  },
  hideAdditionalBox: {
    zIndex: 0
  },
  capitalize: {
    paddingLeft: theme.spacing(0.25),
    textTransform: 'capitalize'
  },
  mobileHeader: {
    flexDirection: 'column'
  },
  mobileHeaderText: {
    fontSize: 24
  }
});

class index extends Component {
  siteId = '';
  defaultLeftRightSpacing = 120;

  constructor(props) {
    super(props);
    const { search, pathname } = props.location;
    const { orderno, status, origin, siteId = '' } = queryString.parse(search);
    this.siteId = siteId;
    if (status) {
      props.setTransactionStatus({ orderNo: orderno, orderStatus: status });
      const forwardPathname = origin ? `${pathname}?origin=${origin}` : pathname;
      forwardTo(forwardPathname);
    }
  }

  state = {
    selectedColumns: [ 'system_id', 'name', 'city', 'state' ],
    filter: {},
    showTooltip: false,
    windowWidth: window.innerWidth - this.defaultLeftRightSpacing,
    checkoutEnabled: false,
    isEligibleSite: true,
    isMobileView: window.innerWidth < 700
  };

  componentDidMount() {
    const { pathname } = this.props.location;
    this.props.getLREPlans({ companyId: this.props.companyId });
    if (isEmpty(this.siteId)) {
      this.updateState({});
    } else {
      this.updateState({ system_id: this.siteId });
      forwardTo(pathname);
    }
    window.addEventListener('resize', this.handleWindowSizeWindow);
  }

  componentDidUpdate() {
    if (!this.state.checkoutEnabled && this.props.sitesDetail.length > 0) {
      this.setState({ checkoutEnabled: true });
    } else if (this.state.checkoutEnabled && this.props.sitesDetail.length <= 0) {
      this.setState({ checkoutEnabled: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeWindow);
  }

  handleWindowSizeWindow = () => {
    const windowWidth = window.innerWidth - this.defaultLeftRightSpacing;
    if (windowWidth !== this.state.windowWidth) {
      this.setState({ windowWidth, isMobileView: window.innerWidth < 700 });
    }
  };

  getLREItemList = () => {
    const { siteData, getLREItems, getPlansBySiteId } = this.props;
    if (siteData && siteData.sites && siteData.sites.length > 0) {
      const siteIds = siteData.sites.map(site => site.system_id);
      getLREItems({ siteIds, successCbk: this.setPurchaseList, isUpdateLreItems: true });
      getPlansBySiteId({ siteIds });
    }
  };

  setPurchaseList = () => {
    const { lreItems, setPurchase, setPurchasedList } = this.props;
    if (lreItems && lreItems.lr_items) {
      lreItems.lr_items.forEach(item => {
        if (item && item.purchase_details && item.purchase_details.length > 0) {
          let isPurchased = false;
          let index = -1;
          for (let i = 0; i < item.purchase_details.length; i++) {
            if (item.purchase_details[i].company_id === this.props.companyId) {
              isPurchased = true;
              index = i;
              break;
            }
          }
          const purchaseIndex = index >= 0 ? index : 0;
          setPurchasedList({
            siteId: item.site_id,
            sku: item.purchase_details[purchaseIndex].sku,
            planEnd: item.purchase_details[purchaseIndex].plan_end,
            companyId: item.purchase_details[purchaseIndex].company_id,
            isExtendedByInstaller: !isPurchased
          });
        }
      });
    }
  };

  fixedEncodeURIComponent = str => {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  };

  updateState = (search, isSearchOrSort = false, page = this.props.siteData.page, sortColumn = {}) => {
    let filter = { ...this.state.filter, ...search };
    let eligibleSiteFilters = {};
    let allSiteFilters = {};
    const columns = [ ...this.state.selectedColumns, 'system_id', 'install_date', 'pcu_channel_count', 'pcu_types' ];
    if (this.state.isEligibleSite) {
      const installedDate = moment(new Date()).subtract(2, 'years').format('M/D/YY');
      // const iqInverters = [ 'IQ6', 'IQ6+', 'IQ7', 'IQ7X', 'IQ7XS', 'IQ7+', 'IQ7A', 'IQ7AS', 'IQ7PD-72', 'IQ7PD-84' ];
      const installDate = get(search, 'install_date', '') || '';
      eligibleSiteFilters = {
        ...filter,
        install_date: installDate || `${installedDate} – `,
        include_lpup: true,
        // is_lpup_system: true, // Show only lpup systems
        // lpp_current_validity: '',
        lpp_eligibility_filters: true
        // pcu_types: iqInverters.join(','),
        // state_not_in: 'NY,OR,PR'
      };
      columns.push('is_lpup_system');
      columns.push('first_iq_inverter_at');
    } else {
      allSiteFilters = { ...filter, install_date: '7/1/05 – ' };
    }
    const { limit } = this.props.siteData;
    if (search) {
      this.setState({ filter });
    }
    const pageNumber = isSearchOrSort ? 1 : page;
    const modifiedFilter = this.state.isEligibleSite ? eligibleSiteFilters : allSiteFilters;
    let modifiedFilterParams = {};
    keysIn(modifiedFilter).forEach(key => {
      if (modifiedFilter[key]) {
        modifiedFilterParams[`site[${key}][text]`] = modifiedFilter[key];
      }
    });
    !isEmpty(keysIn(sortColumn)) &&
      keysIn(sortColumn).forEach(key => {
        if (sortColumn[key]) {
          modifiedFilterParams[`site[${key}][order_by]`] = sortColumn[key];
        }
      });
    const params = {
      columns: columns.join(','),
      limit,
      page: pageNumber,
      ...modifiedFilterParams
    };
    modifiedFilterParams = keysIn(params).map(key => `${key}=${params[key]}`);
    modifiedFilterParams = modifiedFilterParams.join('&');
    this.props.getSiteLists({
      params: modifiedFilterParams,
      successCbk: this.getLREItemList
    });
  };

  updateColumns = event => {
    const selectedColumns = event.target.value;
    const { filter } = this.state;
    keysIn(filter).forEach(key => {
      if (!selectedColumns.includes(key)) {
        delete filter[key];
      }
    });
    this.setState({ selectedColumns, filter }, this.updateState);
  };

  toggleTooltip = show => {
    this.setState({ showTooltip: show });
  };

  toggleEligibleSite = () => {
    this.setState({ isEligibleSite: !this.state.isEligibleSite }, () => this.updateState({}, false, 1));
  };

  getTooltipContent = () => {
    const { classes } = this.props;
    return (
      <Box>
        <Typography component="div">
          {`You can now purchase labor reimbursement coverage extension for IQ™ microinverters for 3 or 8 years thereby
          providing labor coverage for up to 5, or 10 years from the time of product activation. `}
          <Link href="#" onClick={() => window.open(LPPOverview, '_blank')} className={classes.linkColour}>
            Know More
          </Link>
        </Typography>
      </Box>
    );
  };

  getDownloadAgreement = siteId => {
    const { getAgreementFile } = this.props;
    getAgreementFile({
      siteId,
      successCbk: result => {
        const a = document.createElement('a');
        a.href = result.presigned_url;
        a.click();
      }
    });
  };

  render() {
    const {
      classes,
      tier,
      LREPlans,
      siteData,
      message,
      loading,
      purchase,
      circularLoading,
      messageType,
      errorMessage,
      companyId,
      setPurchase,
      updateLREItems,
      addItemsToCart,
      getSelectedItems,
      purchasedList,
      feinNumber = '',
      updateCompanyInfo,
      getLREItems,
      sitesDetail,
      orderNo,
      orderStatus,
      setTransactionStatus,
      fromIFrame,
      lrePlansBySiteId,
      countryCode,
      lppDownloadingAgreement
    } = this.props;
    const { isMobileView } = this.state;
    const TierIconTemplate = tier && tier.name && Icons[tier.name.toLowerCase()];
    const country = getCountryCode(countryCode);
    const lreDiscount = LREPlans && LREPlans.length > 0 && LREPlans[0].discount_percentage;
    return (
      <div className={classes.root}>
        <Box className={clsx(classes.headerWrapper, isMobileView && classes.mobileHeader)}>
          <Box className={classes.headerContainer}>
            <Box className={classes.titleWrapper}>
              <PageHeader className={clsx(isMobileView && classes.mobileHeaderText)} text="Labor Protection Program" />
              <ClickAwayListener onClickAway={() => this.toggleTooltip(false)}>
                <Box>
                  <LightTooltip
                    title={this.getTooltipContent()}
                    placement="bottom-start"
                    open={this.state.showTooltip}
                    arrow
                  >
                    <IconButton onClick={() => this.toggleTooltip(true)} className={classes.headerHelpIcon}>
                      <Avatar className={classes.helpIcon} variant="square" alt="help icon" src={HelpIcon} />
                    </IconButton>
                  </LightTooltip>
                </Box>
              </ClickAwayListener>
            </Box>
            <Typography component="div" className={classes.labelWrapper}>
              <Typography className={classes.important}>*</Typography>
              <Typography className={classes.label}>
                After selecting the relevant extension period for each site, please click on ‘Proceed to Checkout’ to
                complete the process.
              </Typography>
            </Typography>
          </Box>
          <Box className={clsx(classes.flexWrapper, classes.colorWrapper)}>
            {TierIconTemplate && (
              <Fragment>
                <Box className={clsx(classes.additionalBox, !lreDiscount && classes.hideAdditionalBox)} />
                <Box className={classes.tierWrapper}>
                  {lreDiscount && (
                    <Fragment>
                      <Box className={classes.cutboxshadow} />
                      <Box className={classes.discount}>
                        <Box className={classes.discountWrapper}>
                          <Typography className={classes.discountLabel}>You are eligible for</Typography>
                          <Typography className={classes.discountText}>{`${lreDiscount}% Discount`}</Typography>
                          <Box display="flex">
                            <Typography className={classes.discountLabel}>{`as an `}</Typography>
                            <Typography
                              className={clsx(classes.discountLabel, classes.capitalize)}
                            >{` enphase ${tier.name} installer`}</Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Fragment>
                  )}
                  <TierIconTemplate className={classes.tierIcon} countryCode={country} />
                </Box>
              </Fragment>
            )}
          </Box>
        </Box>
        <Systems
          data={siteData}
          selectedColumns={this.state.selectedColumns}
          updateColumns={this.updateColumns}
          LREPlans={LREPlans}
          tier={tier}
          message={message}
          loading={loading}
          updateState={this.updateState}
          setPurchase={setPurchase}
          updateLREItems={updateLREItems}
          addItemsToCart={addItemsToCart}
          getSelectedItems={getSelectedItems}
          purchase={purchase}
          purchasedList={purchasedList}
          companyId={companyId}
          history={this.props.history}
          windowWidth={this.state.windowWidth}
          feinNumber={feinNumber}
          updateCompanyInfo={updateCompanyInfo}
          checkoutEnabled={this.state.checkoutEnabled}
          getLREItems={getLREItems}
          sitesDetail={sitesDetail}
          isEligibleSite={this.state.isEligibleSite}
          toggleEligibleSite={this.toggleEligibleSite}
          isMobileView={isMobileView}
          fromIFrame={fromIFrame}
          lrePlansBySiteId={lrePlansBySiteId}
          selectedSiteId={this.siteId}
          getDownloadAgreement={this.getDownloadAgreement}
        />
        {orderStatus && (
          <OrderStatusPopup orderStatus={orderStatus} orderNo={orderNo} setTransactionStatus={setTransactionStatus} />
        )}
        {(circularLoading || lppDownloadingAgreement) && (
          <Backdrop className={classes.backdrop} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        {messageType === 'error' && <SnakBar message={errorMessage} severity={messageType} />}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getLREPlans: payload => dispatch(getLREPlans(payload)),
  getSiteLists: payload => dispatch(getSiteLists(payload)),
  setPurchase: payload => dispatch(setPurchase(payload)),
  setPurchasedList: payload => dispatch(setPurchasedList(payload)),
  getLREItems: payload => dispatch(getLREItems(payload)),
  updateLREItems: payload => dispatch(updateLREItems(payload)),
  addItemsToCart: payload => dispatch(addItemsToCart(payload)),
  getSelectedItems: payload => dispatch(getSelectedItems(payload)),
  updateCompanyInfo: payload => dispatch(updateCompanyInfo(payload)),
  setTransactionStatus: payload => dispatch(setTransactionStatus(payload)),
  getPlansBySiteId: payload => dispatch(getPlansBySiteId(payload)),
  getAgreementFile: payload => dispatch(getAgreementFile(payload))
});

const mapStateToProps = state => ({
  companyId: state.appReducer.companyId,
  tier: state.appReducer.companyInfo.tier,
  feinNumber: state.appReducer.companyInfo.fein_number,
  LREPlans: state.systemsReducer.LREPlans,
  siteData: state.systemsReducer.siteData,
  message: state.systemsReducer.message,
  loading: state.systemsReducer.loading,
  purchase: state.systemsReducer.purchase,
  purchasedList: state.systemsReducer.purchasedList,
  sitesDetail: state.systemsReducer.sitesDetail,
  lreItems: state.systemsReducer.lreItems,
  circularLoading: state.systemsReducer.circularLoading,
  messageType: state.systemsReducer.messageType,
  errorMessage: state.systemsReducer.errorMessage,
  orderNo: state.systemsReducer.orderNo,
  orderStatus: state.systemsReducer.orderStatus,
  lrePlansBySiteId: state.systemsReducer.lrePlansBySiteId,
  isMobileView: state.appReducer.isMobileView,
  countryCode: state.appReducer.countryCode,
  lppDownloadingAgreement: state.systemsReducer.lppDownloadingAgreement
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(index));
